import React from "react";
import {FormGroup, Label} from "reactstrap";
import CommonSelector from "../../Application/CommonComponents/DropDowns/CommonSelector";

interface backendDropDownProps {
    label: string;
    name: string;
    url: string;
    register: any;
    options: any;
    getValues: any;
    errors?: any;
    params?: any;
    nameColumn?: string;
    onChange?: (event: any) => void;
}

const BackendDropDown = ({
                             label,
                             name,
                             url,
                             register,
                             options,
                             getValues,
                             params,
                             onChange,
                             errors = null,
                             nameColumn = undefined,
                         }: backendDropDownProps) => {

    return (
        <FormGroup>
            <Label
                className={`col-form-label m-0 ${options?.required ? 'required' : null}`}>{label ? label : 'Label'}</Label>
            <CommonSelector
                onChange={onChange}
                params={params}
                options={options}
                register={register}
                url={url}
                name={name}
                value={getValues(name)}
                nameColumn={nameColumn}
            />
            {errors && <span
                className='d-block invalid-feedback'>{errors[name] && (errors[name].message ? errors[name].message : `Please provide a valid ${name}.`)}</span>}
        </FormGroup>
    )
}

export default BackendDropDown;
